module.exports = __webpack_public_path__ + "mainassets/img/graf5-1.5c33e5fd.svg";